import { Permission } from "presentation/constant/ANAInfo/PermissionName";
import { LetPassAccountProvider } from "presentation/store/LetPassAccount/LetPassAccountProvider";
import { ANAInfoWrapper } from "presentation/view/components/ANAInfo/ANAInfoWrapper";
import { MessageBarWrapper } from "presentation/view/components/MessageBarWrapper";
import { LetPassAccountMaintenance } from "presentation/view/section/LetPassAccount/LetPassAccountMaintenance";
import { GridStyles } from "veronica-ui-component/dist/component/core/styled/table.styled";

const LetPassAccountContMain = () => {
    return <ANAInfoWrapper permission={Permission.LET_PASS_ACCOUNT_MAINTENANCE}>
        <MessageBarWrapper>
            <LetPassAccountProvider>
                <GridStyles />
                <LetPassAccountMaintenance />
            </LetPassAccountProvider>
        </MessageBarWrapper>
    </ANAInfoWrapper>
}

export default LetPassAccountContMain;